<template>
  <div>
    <el-dialog
      width="370px"
      :title="$i18.language('发送反馈')"
      :append-to-body="false"
      :close-on-click-modal="true"
      :visible.sync="feedbackType.dialogVisible"
      @close="closeDialog">
      <div class="feedback">
        <div class="wrap" v-for="(item, index) in feedbackTypeList" :key="index" @click="clickFeedback(item)">
          <div class="radio">
            <svg-icon class="check_status" v-if="activedType == item.value" name="checked"></svg-icon>
            <svg-icon class="check_status" v-else name="uncheck"></svg-icon>
          </div>
          <span class="feedbackType" :class="activedType == item.value ? 'actived' : ''">{{ item.text }}</span>
        </div>
      </div>
      <div class="input">
        <span class="other">{{ $t("other") }}</span>
        <el-input type="textarea" @keyup.native="changeInput" :maxlength="280" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$i18.language('请输入其他原因')" v-model="otherTextarea"></el-input>
      </div>
      <div class="send">
        <el-button @click="sendfeedBack">{{ $i18.language("提交") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    feedbackType: {
      type: Object,
      default: () => {return {row: {score: 0}, dialogVisible: false}}
    }
  },
  data() {
    return {
      activedType: this.feedbackType.row.score,
      otherTextarea: this.feedbackType.row.cause || "",
      feedbackTypeList: [
        {
          text: this.$i18.language("信息错误"),
          value: 2
        },
        {
          text: this.$i18.language("没有帮助"),
          value: 3
        },
      ]
    };
  },
  methods: {
    changeInput: _.debounce(function () {
      if (this.otherTextarea.trim().length >= 280) {
        return this.$message.warning(this.$i18.language("输入字符过长!"))
      }
    }, 300),
    closeDialog(){
      this.$parent.feedbackDialog = false
    },
    sendfeedBack(){
      // 如果都不选并且原因也为空
      if (this.otherTextarea.length <= 0 && this.activedType != 2 && this.activedType != 3) {
        return this.$parent.feedbackType = {row: {score: 0}, dialogVisible: false}
      }
      // 如果只输入原因
      if (this.activedType != 2 && this.activedType != 3 && this.otherTextarea.length > 0) {
        this.activedType = 4
      }
      this.$parent.feedback({...this.feedbackType.row, cause: this.otherTextarea}, this.activedType)
      this.$parent.feedbackType = {row: {score: 0}, dialogVisible: false}
    },
    clickFeedback(item) {
      this.activedType = item.value
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog {
  width: 20%;
  .feedback {
    display: flex;
  }
  .wrap{
    width: 70%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 0 auto;
    .feedbackType {
      cursor: pointer;
    }
    .radio {
      svg {
        width: 14px;
        height: 14px;
      }
    }
    .actived {
      color: $--color-active-6 !important;
    }
    .el-button {
      border-radius: 5px;
      margin-bottom: 15px;
      &:hover, &:active, &:focus {
        color: $--color-active-6 !important;
        border-color: $--color-active-6 !important;
      }
    }
  }
  .input {
    .other {
      display: block;
      margin: 15px 0 8px;
    }
    .el-textarea {
      margin-bottom: 8px;
    }
  }
  .send {
    display: flex;
    justify-content: flex-end;
    .el-button {
      border: 0;
      border-radius: 5px;
      color: $--btn-font;
      background-color: $--color-active-6;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
